<template>
  <b-card title="">
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'complaintCode'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.complaintCode }}</span>
        </span>

        <span v-if="props.column.field === 'complaintDate'" class="text-nowrap">
          <span class="text-nowrap"
            >{{ props.row.complaintDateStr }} /
            {{ props.row.channelName }}</span
          >
        </span>

        <!-- <span v-if="props.column.field === 'companyName'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.companyName }}</span>
        </span> -->
        <span v-if="props.column.field === 'companyName'" class="text-nowrap">
          <span
            v-for="(item, index) in props.row.companyNameList"
            class="text-nowarp"
            v-b-tooltip.hover
            :key="index"
            :title="item"
          >
            <feather-icon icon="BriefcaseIcon" class="mr-50" />
            {{ item.substring(0, 50) }}{{ item.length >= 50 ? "..." : "" }}
            <br />
          </span>
          <span
            v-for="(item, index) in props.row.ownerNameList"
            :key="index"
            class="text-nowarp"
          >
            <feather-icon icon="UserIcon" class="mr-50" />
            {{ item }}
            <br />
          </span>
          <span
            v-for="(item, index) in props.row.minionNameList"
            :key="index"
            class="text-nowarp"
          >
            <feather-icon icon="UsersIcon" class="mr-50" />
            {{ item }}
            <br />
          </span>
          <span v-if="resolvePartyName(props.row)">
            {{ resolvePartyName(props.row) }}
          </span>
        </span>

        <span v-if="props.column.field === 'status'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.status }}</span>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '25', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BTab,
  BTabs,
  BOverlay,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";

import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";

import TableHeaders from "./commonTableHeader.js";

// import * as userData from "@/auth/localStorageUtils.js";
// import * as complaintGroupStore from "@/store/api/complaint/complaintGroup.js";

import * as apiDashboard from "@/store/api/dashboard/index.js";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,

    TableHeaders,
    BTab,
    BTabs,
    BOverlay,
    BCard,
    BTooltip,
  },
  props: {
    headers: [],
    filter: {
      year: "",
      yearEnd: "",
      startDate: "",
      endDate: "",
      userId: null,
      departmentId: "",
    },
  },
  mounted() {
    // //console.log"mounted.commontable .filter", this.filter);
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
      keyword: "",
      params: {},
      totalRecords: 0,
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      qllIdsList: [],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    // //console.log"created.commontable .filter", this.filter);
    // //console.log"created.commontable .headers", this.headers);
  },
  methods: {
    // ผู้ประกอบการ / ชื่อผู้ร้องทุกข์ หรือ ผู้มอบอำนาจ - ไล่ตามลำดับ ตัวไหนมีค่าก่อนใช้ตัวนั้น
    resolvePartyName(row) {
      const candidates = [row.companyName, row.complainantName, row.attorneyName];

      const found = candidates.find(
        (value) => value != null && String(value).trim() !== ""
      );

      return found == null ? "" : String(found).trim();
    },
    onPageChange(page) {
      //console.log"methods.commontable.onpagechange .page", page);
      // ต้องส่ง keyword เป็น arg ตัวแรก ไม่ใช่ params ไม่งั้นไม่ตรง branch ไหนเลย
      this.onSearchSubmit(this.keyword, this.params, page);
    },
    onPageLengthChange(pageLength) {
      //console.log
      //   "methods.commontable.onpagelengthchange .pagelength",
      //   pageLength
      // );
      // page ต้องเป็น object { currentPage } ไม่ใช่ตัวเลข
      this.onSearchSubmit(this.keyword, this.params, { currentPage: 1 });
    },
    onSearchSubmit(keyword, params, page = { currentPage: 1 }) {
      //console.log"methods.commontable.onsearchsubmit .params", params);
      //console.log"methods.commontable.onsearchsubmit .page", page);

      const _this = this;
      // เก็บไว้ให้ onPageChange / onPageLengthChange เรียกซ้ำได้ด้วยเงื่อนไขเดิม
      _this.keyword = keyword;
      _this.params = params;
      // if (_this.qlId) params.qlId = _this.qlId;
      params.page = page.currentPage;
      params.perPage = _this.pageLength;

      //console.log"methods.commontable.onsearchsubmit .keyword", keyword);

      if (keyword === "COMPLAINT_ALL") {
        // ต้องตั้ง Mode ทุกครั้ง: params คือ object filter ตัวเดียวกับหน้า dashboard
        // ถ้าเคยคลิกกล่อง IN_ADMIN / SENT_OFFICER มาก่อน Mode จะค้างอยู่
        params.Mode = "ALL";
        apiDashboard
          .GetBoxChart_SummaryAdminComplaintFromScreening(params)
          .then(function(response) {
            console.log("COMPLAINT_ALL", response);
            _this.totalRecords = response.data.data[0].totalCount;
            _this.rows = response.data.data;

            //console.log"complaint.center .rows", _this.rows);
          })
          .catch(function(error) {
            //console.log"complaint.center .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (
        keyword === "ADMIN_IN_DEPARTMENT" ||
        keyword === "ADMIN_SENT_OFFICER"
      ) {
        // กล่องหน้าธุรการกอง : อยู่ในธุรการกอง (IN_ADMIN) / ส่งไปเจ้าหน้าที่แล้ว (SENT_OFFICER)
        params.Mode =
          keyword === "ADMIN_IN_DEPARTMENT" ? "IN_ADMIN" : "SENT_OFFICER";
        apiDashboard
          .GetBoxChart_SummaryAdminComplaintFromScreening(params)
          .then(function(response) {
            const rows = response.data.data || [];
            _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
            _this.rows = rows;
          })
          .catch(function(error) {
            console.log(`${keyword} .error`, error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (keyword === "SCREENING_VALID_ALL") {
        params.Mode = "ALL";
        apiDashboard
          .GetBoxChart_SummaryScreeningValidDetails(params)
          .then(function(response) {
            //console.log"complaint.center .response", response);
            _this.totalRecords = response.data.data[0].totalCount;
            _this.rows = response.data.data;

            //console.log"complaint.center .rows", _this.rows);
          })
          .catch(function(error) {
            //console.log"complaint.center .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (keyword === "SCREENING_VALID_VALID") {
        params.Mode = "VALID";
        apiDashboard
          .GetBoxChart_SummaryScreeningValidDetails(params)
          .then(function(response) {
            //console.log"complaint.center .response", response);
            _this.totalRecords = response.data.data[0].totalCount;
            _this.rows = response.data.data;

            //console.log"complaint.center .rows", _this.rows);
          })
          .catch(function(error) {
            //console.log"complaint.center .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (keyword === "SCREENING_VALID_INVALID") {
        params.Mode = "INVALID";
        apiDashboard
        .GetBoxChart_SummaryScreeningValidDetails(params)
        .then(function(response) {
          //console.log"complaint.center .response", response);
          _this.totalRecords = response.data.data[0].totalCount;
          _this.rows = response.data.data;

          //console.log"complaint.center .rows", _this.rows);
        })
        .catch(function(error) {
          //console.log"complaint.center .error", error);
        })
        .then(function() {
          _this.$emit("handleOverlay", false);
        });
      } else if (keyword === "FASTTRACK_ROLE_OFFICER_ALL_RECEIVE") {
        apiDashboard
        .GetBoxChart_SummaryOfficerComplaintIncomeDetails(params)
        .then(function(response) {
          console.log("FASTTRACK_ROLE_OFFICER_ALL_RECEIVE", response);
          const rows = response.data.data || [];
          // guard: ถ้าไม่มีแถว data[0] จะ undefined แล้ว throw เข้า catch ทำให้ตารางว่างแบบเงียบ
          _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
          _this.rows = rows;
        })
        .catch(function(error) {
          //console.log"complaint.center .error", error);
        })
        .then(function() {
          _this.$emit("handleOverlay", false);
        });
      } else if (keyword === "FASTTRACK_ROLE_OFFICER_INCOME_MOU") {
        // ถืออยู่และยังอยู่ระหว่างดำเนินการที่บริษัท (Group 100 ใน SP)
        params.Group = "ON_FASTTRACK";
        params.TargetId = null; // กล่องไม่กรองบริษัท

        apiDashboard
        .GetBoxChart_SummaryOfficerComplaintMouIncomeDetails(params)
        .then(function(response) {
          console.log("GetBoxChart_SummaryOfficerComplaintMouIncomeDetails = ", response);
          const rows = response.data.data || [];
          // guard: ถ้าไม่มีแถว data[0] จะ undefined แล้ว throw เข้า catch ทำให้ตารางว่างแบบเงียบ
          _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
          _this.rows = rows;
        })
        .catch(function(error) {

        })
        .then(function() {
          _this.$emit("handleOverlay", false);
        });
      } else if (keyword === "FASTTRACK_ROLE_OFFICER_INCOME_MOU_LIST") {
        // เจ้าหน้าที่คนนี้กดส่ง Fasttrack เอง (Group 200 ใน SP)
        params.Group = "SELF_SENT";
        params.TargetId = null; // กล่องไม่กรองบริษัท
        apiDashboard
        .GetBoxChart_SummaryOfficerComplaintMouIncomeDetails(params)
        .then(function(response) {
          const rows = response.data.data || [];
          _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
          _this.rows = rows;
        })
        .catch(function(error) {

        })
        .then(function() {
          _this.$emit("handleOverlay", false);
        })
      } else if (keyword === "FASTTRACK_ROLE_OFFICER_STATUS") {
        // drill-down ตาราง 2 หน้าเจ้าหน้าที่ : เรื่องของสถานะที่คลิก (สถานะจากระบบ Fasttrack, params.Mode = ชื่อสถานะ)
        apiDashboard
          .OfficerTableChartyComplaintUnderOfficerDetails(params)
          .then(function(response) {
            const rows = response.data.data || [];
            _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
            _this.rows = rows;
          })
          .catch(function(error) {
            console.log("FASTTRACK_ROLE_OFFICER_STATUS .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (keyword === "FASTTRACK_ROLE_OFFICER_COMPANY") {
        // drill-down ตาราง 1 หน้าเจ้าหน้าที่ : เรื่องที่ส่ง Fasttrack ไปบริษัทที่คลิก (Group 300 ใน SP)
        params.Group = "ALL_SENT";
        apiDashboard
          .GetBoxChart_SummaryOfficerComplaintMouIncomeDetails(params)
          .then(function(response) {
            const rows = response.data.data || [];
            _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
            _this.rows = rows;
          })
          .catch(function(error) {
            console.log("FASTTRACK_ROLE_OFFICER_COMPANY .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (keyword === "SCREENING_SENDING_COMPANY") {
        // table chart 1 : เรื่องที่คัดกรองส่งไปผู้ประกอบการรายที่คลิก (สถานะ 514 + 518)
        params.Mode = "COMPANY";
        apiDashboard
          .ScreeningTableChartSendingDetails(params)
          .then(function(response) {
            const rows = response.data.data || [];
            // guard: ถ้าไม่มีแถว data[0] จะ undefined แล้ว throw เข้า catch ทำให้ตารางว่างแบบเงียบ
            _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
            _this.rows = rows;
          })
          .catch(function(error) {
            console.log("SCREENING_SENDING_COMPANY .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (keyword === "SCREENING_SENDING_DEPARTMENT") {
        // table chart 2 : เรื่องที่คัดกรองส่งไปหน่วยงานที่คลิก (สถานะ 514 + 9)
        params.Mode = "DEPARTMENT";
        apiDashboard
          .ScreeningTableChartSendingDetails(params)
          .then(function(response) {
            const rows = response.data.data || [];
            _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
            _this.rows = rows;
          })
          .catch(function(error) {
            console.log("SCREENING_SENDING_DEPARTMENT .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (keyword === "ADMIN_FROM_SCREENING_COMPANY") {
        // drill-down ตาราง 1 หน้าธุรการกอง : เรื่องของบริษัทที่คลิก ที่เข้ากองนี้ (สถานะ 514 + 9 จากคัดกรอง)
        apiDashboard
          .AdminChartsSummaryComplaintFromScreeningCompanyDetails(params)
          .then(function(response) {
            const rows = response.data.data || [];
            // guard: ถ้าไม่มีแถว data[0] จะ undefined แล้ว throw เข้า catch ทำให้ตารางว่างแบบเงียบ
            _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
            _this.rows = rows;
          })
          .catch(function(error) {
            console.log("ADMIN_FROM_SCREENING_COMPANY .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (keyword === "ADMIN_SENT_OFFICER_DETAILS") {
        // drill-down ตาราง 2 หน้าธุรการกอง : เรื่องที่ค้างในมือเจ้าหน้าที่คนที่คลิก
        apiDashboard
          .AdminTableChartSentOfficerDetails(params)
          .then(function(response) {
            const rows = response.data.data || [];
            _this.totalRecords = rows.length > 0 ? rows[0].totalCount : 0;
            _this.rows = rows;
          })
          .catch(function(error) {
            console.log("ADMIN_SENT_OFFICER_DETAILS .error", error);
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else {
        console.log("commonTable")
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>